import { dataExcellentBookmarkSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconExcellentBookmarkSolid = /*#__PURE__*/createIcon(dataExcellentBookmarkSolid)
export default IconExcellentBookmarkSolid
